import { render, staticRenderFns } from "./GroupChangeSave.vue?vue&type=template&id=37571666&"
import script from "./GroupChangeSave.vue?vue&type=script&lang=js&"
export * from "./GroupChangeSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports